import CommonApp from '../app.js';
import {configManager} from '../../util/config-manager/config-manager.js';

var BirthdayFactory = function($http, $q, $window) {
    var months = [
        {
            code: 1,
            desc: 'JAN'
        },
        {
            code: 2,
            desc: 'FEB'
        },
        {
            code: 3,
            desc: 'MAR'
        },
        {
            code: 4,
            desc: 'APR'
        },
        {
            code: 5,
            desc: 'MAY'
        },
        {
            code: 6,
            desc: 'JUNE'
        },
        {
            code: 7,
            desc: 'JULY'
        },
        {
            code: 8,
            desc: 'AUG'
        },
        {
            code: 9,
            desc: 'SEPT'
        },
        {
            code: 10,
            desc: 'OCT'
        },
        {
            code: 11,
            desc: 'NOV'
        },
        {
            code: 12,
            desc: 'DEC'
        }
    ];

    var days = [
        {code: 1, desc: '1'},
        {code: 2, desc: '2'},
        {code: 3, desc: '3'},
        {code: 4, desc: '4'},
        {code: 5, desc: '5'},
        {code: 6, desc: '6'},
        {code: 7, desc: '7'},
        {code: 8, desc: '8'},
        {code: 9, desc: '9'},
        {code: 10, desc: '10'},
        {code: 11, desc: '11'},
        {code: 12, desc: '12'},
        {code: 13, desc: '13'},
        {code: 14, desc: '14'},
        {code: 15, desc: '15'},
        {code: 16, desc: '16'},
        {code: 17, desc: '17'},
        {code: 18, desc: '18'},
        {code: 19, desc: '19'},
        {code: 20, desc: '20'},
        {code: 21, desc: '21'},
        {code: 22, desc: '22'},
        {code: 23, desc: '23'},
        {code: 24, desc: '24'},
        {code: 25, desc: '25'},
        {code: 26, desc: '26'},
        {code: 27, desc: '27'},
        {code: 28, desc: '28'},
        {code: 29, desc: '29'},
        {code: 30, desc: '30'},
        {code: 31, desc: '31'}
    ];

    var has31days = ['JAN', 'MAR', 'MAY', 'JULY', 'AUG', 'OCT', 'DEC'];
    var has30days = ['APR', 'JUNE', 'SEPT', 'NOV'];
    var has29days = ['FEB'];
    var factoryObj = {};

    var getDays = function(dayLength) {
        return _.take(days, dayLength);
    };

    var generateYears = function(ageLimit) {
        var years = [];
        var currentYear = new Date().getFullYear();
        if (!ageLimit) {
            ageLimit = 18;
        }  
        for (var i = parseInt(currentYear)-parseInt(ageLimit); i > (parseInt(currentYear)-100); i--) {
            years.push(i);
        }
        return years;
    };

    factoryObj.getMonths = function() {
        return months;
    }; 

    factoryObj.getDaysForMonth = function(monthCode) {
        var month = _.result(_.find(months, {code: monthCode}), 'desc');

        if (typeof _.contains !== 'undefined') {
            if (_.contains(has31days, month)) {
                return getDays(31);
            }
            if (_.contains(has30days, month)) {
                return getDays(30);
            }
            if (_.contains(has29days, month)) {
                return getDays(29);
            }
        } else {
            if (_.includes(has31days, month)) {
                return getDays(31);
            }
            if (_.includes(has30days, month)) {
                return getDays(30);
            }
            if (_.includes(has29days, month)) {
                return getDays(29);
            }
        }
    };

    factoryObj.getDaysListDefault = function() {
        return getDays(31);
    };

    factoryObj.getYears = function(ageLimit) {
        return generateYears(ageLimit);
    };

    factoryObj.findItemById = function(id, flag) {
        var returnItem;
        if (flag == 'M') {
            var baseArray = months;
        }
        if (flag == 'D') {
            var baseArray = days;
        }
        angular.forEach(baseArray, function(value) {
            if (value.code == id) {
                returnItem = value.code;
            }
        });
        return returnItem;
    };

    return factoryObj;
};

BirthdayFactory.$inject = ['$http', '$q', '$window'];
CommonApp.module.factory('birthdayFactory', BirthdayFactory);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/factory/birthday-fact.js
// module id = 278
// module chunks = 0